<script lang="ts">
  import { T, useTask } from '@threlte/core';
  import { useTexture } from '@threlte/extras';
  import { MeshBasicMaterial, SRGBColorSpace, Vector2 } from 'three';

  export let percent = 0;
  export let GroupRotation = 0;
  export let type: 's3' | 'x2' | 'card' = 's3';

  export let args = [0.54, 0.46];
  export let textures: { reflection: string; alpha?: string };
  export let isMobile = false;
  export let section = 0;
  export let opacity = 1;
  let plane: any;
  let previousPercent = 0;
  // eslint-disable-next-line unicorn/prefer-top-level-await
  const reflection = useTexture(textures).then((texture) => {
    texture.reflection.colorSpace = SRGBColorSpace;
    const material = new MeshBasicMaterial({
      map: texture.reflection,
      alphaMap: texture.alpha,
      transparent: true,
      opacity,
    });

    return material;
  });

  const ease = (x: number) => x;
  const getRotation = (normalizedPercent: number) => {
    if (type === 'card') {
      return 0;
    }
    if (type === 's3') {
      if (section === 0) {
        return -1.9 + normalizedPercent * 1.5;
      } else if (section === 1) {
        return -0.4 + normalizedPercent * 1.5;
      }

      return isMobile ? normalizedPercent * 2.2 + -0.8 : normalizedPercent * 2.2 + -1.4;
    }
    return ease(1 - normalizedPercent) * -2.6 - 0.4;
  };

  useTask(() => {
    if (plane && percent !== previousPercent) {
      const normalizedPercent = isMobile ? percent + 1 : percent;

      const finalRotation = getRotation(normalizedPercent);

      if (finalRotation > 0) {
        plane.material.map.center = new Vector2(0 + 0.005, 1);
      } else {
        plane.material.map.center = new Vector2(1 - 0.005, 1);
      }

      if (type === 'card') {
        plane.material.map.repeat = new Vector2(1, 0.74);
        plane.material.map.offset = new Vector2(0.05 * (1 - normalizedPercent), 0);
        plane.material.opacity = opacity;
      } else if (type === 's3') {
        plane.material.map.repeat = new Vector2(1, 0.7);
      } else {
        plane.material.map.repeat = new Vector2(1, 0.6);
        plane.material.map.offset = new Vector2(-0.06, 0);
        plane.material.alphaMap.offset = new Vector2(0, -0.05 * (1 - normalizedPercent));
      }

      plane.material.map.rotation = finalRotation;
      previousPercent = percent;
    }
  });
</script>

{#await reflection then reflection}
  <T.Group {...$$restProps}>
    <T.Mesh bind:ref={plane} material={reflection}>
      <T.PlaneGeometry {args} />
    </T.Mesh>
  </T.Group>
{/await}
